













































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ActivitySection from "@/components/common/index/ActivitySection.vue";

@Component({
  components: {
    "activity-section": ActivitySection
  }
})
export default class JoinModal extends Vue {
  @Prop({ default: false, type: Boolean })  visible!: boolean;
  
  handleCloseModal() {
    (this as any).cancel();
  }
  handleFindOthers() {
    (this as any).ok();
  }
}
